import { SiteReviewForm } from "./site_reviews__id";

export default function AdminNewSiteReviewPage() {
  return <SiteReviewForm />;
}
